import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const StyledBox = styled(Box)({
  position: 'absolute',
  height: '40px',
  top: '6px'
});



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPromptAnswer/styles.js